export default {
    computed: {
        tinyMCEApiKey() {
            return process.env.VUE_APP_TINY_MCE_API_KEY;
        }
    }
};
